export default {
    "payment_list_payments_made": "Pagos realizados",

    "payment_list_id_document": "Id documento",
    "payment_list_number": "Número",
    "payment_list_payment_date": "Fecha",
    "payment_list_payment_total": "Total",
    "payment_list_brand": "Marca",
    "payment_list_payment_place": "Punto de venta"
}